import { createContext, useContext } from "react";

export type LogTagContextType = {
  readonly LOG_TAG: string;
};

export const LogTagContext = createContext({} as LogTagContextType);

export const useLogTag = () => useContext(LogTagContext);
